import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as Home } from '@assets/icons/home.svg';
import { ReactComponent as Briefcase } from '@assets/icons/briefcase.svg';
import { ReactComponent as BloodDropIcon } from '@assets/icons/collection-blood-drop.svg';
import { ReactComponent as SalivaIcon } from '@assets/icons/collection-saliva.svg';
import { ReactComponent as BuccalIcon } from '@assets/icons/collection-buccal.svg';

export const StyledReceivedSamplesContainer = styled(Box, {
  display: 'flex',
});

export const StyledHomeIcon = styled(Home, {});
export const StyledBriefcaseIcon = styled(Briefcase, {});

export const StyledBloodDropIcon = styled(BloodDropIcon, {});

export const StyledSalivaIcon = styled(SalivaIcon, {});

export const StyledBuccalIcon = styled(BuccalIcon, {});

export const StyledTitle = styled(Box, {
  color: '$darkGray300',
  fontSize: '$sm',
  fontWeight: '$bold',
  letterSpacing: '0.5px',
  lineHeight: '$4',
  marginBottom: '$4',
  textAlign: 'left',
  textTransform: 'uppercase',
});
